import {
  type Theme,
  type ThemeOptions,
  type ComponentsProps,
  type ComponentsOverrides,
  type ComponentsVariants
} from '@mui/material/styles';
import { ImageVariants } from './Image.types';

const defaultProps: ComponentsProps['Image'] = {
  variant: ImageVariants.default
};

const styleOverrides: ComponentsOverrides<Theme>['Image'] = {
  root: {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }
};

const createVariants = (_theme: Theme): ComponentsVariants['Image'] => [];

export const imageTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Image: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default imageTheme;
